import PropTypes from 'prop-types';
import cc from 'classcat';

import styles from './styles.module.scss';

const Label = ({ children, className, value }) => (
  <label>
    {value && <div className={cc([styles.label, className])}>{value}</div>}
    {children}
  </label>
);

Label.propTypes = {
  value: PropTypes.string,
};

Label.displayName = 'Label';

export { Label };
